import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { apiPost } from '../../lib/api.js';
import { twoPartyMessage } from '../../lib/dialGuards.js';

/**
 * Persistent banner on an active call when the prospect is in a two-party
 * (all-party) recording-consent state. Renders nothing otherwise.
 * @param {{callState: string, leadId?: string|null, phone?: string}} props
 * @returns {JSX.Element|null}
 */
export default function CallScreenAlert({ callState, leadId, phone }) {
  const active = callState === 'in-progress' && !!(leadId || phone);
  const { data } = useQuery({
    queryKey: ['two-party-consent', leadId || phone],
    queryFn: () => apiPost('/phone/dial-precheck', leadId ? { leadId } : { phone }),
    enabled: active,
    staleTime: 5 * 60 * 1000,
  });
  const twoParty = data?.data?.twoParty;
  if (!active || !twoParty?.required) return null;
  return (
    <div role="alert" data-testid="two-party-banner" className="bg-amber-400 text-black text-sm font-semibold px-3 py-2 leading-snug">
      <span aria-hidden="true">⚠️ </span>{twoPartyMessage(twoParty)}
    </div>
  );
}
